const sortPostbySections = (posts) => {
  return posts.map(pos => {
    pos.sections = sortBySections(pos);
    return pos;
  })
}
const sortBySections = (pos) => pos.sections.sort((a, b) => a.position - b.position);
export { sortPostbySections, sortBySections };
